import React from "react";
import { Avatar } from "@mui/material";
import logo from "../../media/logo-biai.png";

export const CompanyAvatar: React.FC = () => (
  <Avatar
    src={logo}
    alt="Entorno Biai Logo"
    sx={{ width: { xs: 44, sm: 60 }, height: { xs: 44, sm: 60 }, borderRadius: "50%" }}
  />
);
